import { create } from "zustand";

type SearchStore = {
    formValues?: SearchFormInputs;
    formTouched: boolean;
    mobileFormOpen: boolean;
    setMobileFormOpen: (open: boolean) => void;
    setFormValues: (formValues: SearchFormInputs) => void;
    setFormTouched: (formTouched: boolean) => void;
};

export const useSearchStore = create<SearchStore>((set) => ({
    formValues: undefined,
    setFormValues: (formValues) => set({ formValues }),
    formTouched: false,
    setFormTouched: (formTouched) => set({ formTouched }),
    mobileFormOpen: false,
    setMobileFormOpen: (mobileFormOpen) => set({ mobileFormOpen })
}));
